import { Component, type ErrorInfo, type ReactNode } from 'react';
import { getUserFacingErrorMessage } from '@/shared/errors/user-facing-error';

type Props = { children: ReactNode };
type State = { error: unknown | null };

/** Last-resort UI for render/lifecycle errors; implementation details stay in console. */
export class AppErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: unknown): State {
    return { error };
  }

  componentDidCatch(error: unknown, info: ErrorInfo): void {
    console.error('Unhandled application error', error, info.componentStack);
  }

  render() {
    if (this.state.error === null) return this.props.children;
    return (
      <main className="grid min-h-svh place-items-center p-6">
        <section className="max-w-md rounded-xl border border-destructive/30 bg-card p-6 text-center shadow-sm">
          <h1 className="text-lg font-semibold">页面出了点问题</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            {getUserFacingErrorMessage(this.state.error, '页面暂时无法显示，请刷新后重试。')}
          </p>
          <button
            className="mt-5 rounded-md bg-primary px-4 py-2 text-sm text-primary-foreground"
            onClick={() => window.location.reload()}
          >
            刷新页面
          </button>
        </section>
      </main>
    );
  }
}
